import { createReducer, on, ActionReducerMap } from '@ngrx/store';
import * as UserActions from './user.actions';
import { ReadonlyCollection } from '@mode/shared/contract-common';
import { UserTypes } from '@mode/shared/contract-common';

export const userFeatureKey = 'user';

export interface State {
  isComplete: boolean;
  isAnonymous: boolean;
  isLoading: boolean;
  selfError: Error | null;
  self: UserTypes.User | undefined;

  organizations: ReadonlyCollection<UserTypes.UserOrganization> | undefined;
  isOrganizationsLoading: boolean;
  isOrganizationsComplete: boolean;
  organizationsError: Error | null;
}

export const initialState: State = {
  isLoading: false,
  isComplete: false,
  isAnonymous: false,
  self: undefined,
  selfError: null,
  organizations: undefined,
  isOrganizationsComplete: false,
  isOrganizationsLoading: false,
  organizationsError: null,
};

export const isCompleteReducer = createReducer(
  initialState.isComplete,
  on(UserActions.loadAnonymousUser, (state) => true),
  on(UserActions.loadCurrentUser, (state) => false),
  on(UserActions.loadCurrentUserSuccess, (state) => true),
  on(UserActions.loadCurrentUserFailure, (state) => true)
);

export const isLoadingReducer = createReducer(
  initialState.isLoading,
  on(UserActions.loadAnonymousUser, (state) => false),
  on(UserActions.loadCurrentUser, (state) => true),
  on(UserActions.loadCurrentUserSuccess, (state) => false),
  on(UserActions.loadCurrentUserFailure, (state) => false)
);

export const isAnonymousReducer = createReducer(
  initialState.isAnonymous,
  on(UserActions.loadAnonymousUser, (state) => true),
  on(UserActions.loadCurrentUserSuccess, (state) => false),
  on(UserActions.loadCurrentUserFailure, (state) => false)
);

export const selfReducer = createReducer(
  initialState.self,
  on(UserActions.loadCurrentUser, (state) => state),
  on(UserActions.loadCurrentUserSuccess, (state, action) => action.user),
  on(UserActions.loadCurrentUserFailure, (state, action) => undefined)
);

export const selfErrorReducer = createReducer(
  initialState.selfError,
  on(UserActions.loadCurrentUser, UserActions.loadAnonymousUser, (state) => null),
  on(UserActions.loadCurrentUserFailure, (state, action) => action.error)
);

export const isOrganizationsCompleteReducer = createReducer(
  initialState.isOrganizationsComplete,
  on(UserActions.loadUserOrgs, (state) => false),
  on(UserActions.loadUserOrgsSuccess, (state) => true),
  on(UserActions.loadUserOrgsFailure, (state) => true)
);

export const isOrganizationsLoadingReducer = createReducer(
  initialState.isOrganizationsLoading,
  on(UserActions.loadUserOrgs, (state) => true),
  on(UserActions.loadUserOrgsSuccess, (state) => false),
  on(UserActions.loadUserOrgsFailure, (state) => false)
);

export const organizationsReducer = createReducer(
  initialState.organizations,
  on(UserActions.loadUserOrgsSuccess, (state, action) => action.orgs),
  on(UserActions.loadUserOrgsFailure, (state, action) => undefined)
);

export const organizationsErrorReducer = createReducer(
  initialState.organizationsError,
  on(UserActions.loadUserOrgs, (state) => null),
  on(UserActions.loadUserOrgsFailure, (state, action) => action.error)
);

export const reducer: ActionReducerMap<State> = {
  isComplete: isCompleteReducer,
  isLoading: isLoadingReducer,
  isAnonymous: isAnonymousReducer,
  self: selfReducer,
  selfError: selfErrorReducer,

  isOrganizationsComplete: isOrganizationsCompleteReducer,
  isOrganizationsLoading: isOrganizationsLoadingReducer,
  organizations: organizationsReducer,
  organizationsError: organizationsErrorReducer,
};
